import type { MenuDisplayData } from "./menuDisplayData"

// The display runs on shop TVs where nobody can log in or reload by hand, so the last successful
// menu is kept in localStorage and shown after a reboot even while the backend is unreachable.
const MENU_DISPLAY_CACHE_KEY_PREFIX = "menu-display-cache:"

export type MenuDisplayCacheRecord = Readonly<{
    savedAtMillis: number
    forDate: string
    data: MenuDisplayData
}>

function isMenuDisplayCacheRecord(value: unknown): value is MenuDisplayCacheRecord {
    return (
        typeof value === "object" &&
        value !== null &&
        "savedAtMillis" in value &&
        typeof value.savedAtMillis === "number" &&
        "forDate" in value &&
        typeof value.forDate === "string" &&
        "data" in value &&
        typeof value.data === "object" &&
        value.data !== null &&
        "items" in value.data &&
        Array.isArray(value.data.items)
    )
}

export function readMenuDisplayCache(merchantUid: string): MenuDisplayCacheRecord | undefined {
    try {
        const raw = window.localStorage.getItem(MENU_DISPLAY_CACHE_KEY_PREFIX + merchantUid)
        if (!raw) return undefined
        const parsed: unknown = JSON.parse(raw)
        return isMenuDisplayCacheRecord(parsed) ? parsed : undefined
    } catch {
        return undefined
    }
}

export function writeMenuDisplayCache(merchantUid: string, record: MenuDisplayCacheRecord): void {
    try {
        window.localStorage.setItem(MENU_DISPLAY_CACHE_KEY_PREFIX + merchantUid, JSON.stringify(record))
    } catch {
        // Storage can be unavailable (private mode, quota); the display only loses reload resilience.
    }
}
